import React, { useState } from "react";
import { Card, CardContent, Chip, IconButton, Tooltip } from "@mui/material";
import ContentCopyIcon from '@mui/icons-material/ContentCopy';
import { ConfirmPopup } from "../../../../Components/Common Components/CommonComponents";
import { Serviceurls } from "../../../../Utility/API/Serviceurls";
import RestAPIService from "../../../../Utility/Services/RestAPIService";

export const DoctorNotesApiMap = {
  patient_categories: Serviceurls.AYURVEDA_PATIENT_CATEGORIES,
  past_presenting_complaints: Serviceurls.AYURVEDA_PAST_COMPLAINTS,
  expected_outcome: Serviceurls.AYURVEDA_EXPECTED_OUTCOME,
  new_presenting_complaints: Serviceurls.AYURVEDA_NEW_COMPLAINTS,
  systemic_examination: Serviceurls.AYURVEDA_SYSTEMIC_EXAMINATION,
  ayurvedic_diagnosis: Serviceurls.AYURVEDA_DOCTOR_DIAGNOSIS,
  allopathic_diagnosis: Serviceurls.AYURVEDA_ALLOPATHIC_DIAGNOSIS,
  current_allopathic_medication: Serviceurls.AYURVEDA_ALLOPATHIC_MEDICATION,
  general_advice: Serviceurls.AYURVEDA_GENERAL_ADVICE,
};

const DocLastVisitRecords = (props) => {

    const [state, setState] = useState({
        movePopup: false,
    })


    const updateState = (updates) => {
        setState((prev) => ({ ...prev, ...updates }));
    };


    const closemovePop = () => {
        updateState({
            movePopup: false
        })
    }

    const confirmMovedata = () => {
        try {
            let data = props?.isFromIp
                ? { ip_admission_id: props.ipAdmissionId, clinic_id: props.clinicId, doctor_id: props.doctorId, fromLastVisit: true, last_visit_appointment_id: props.old_appointmrntId }
                : { appointment_id: props.appointmentId, fromLastVisit: true, last_visit_appointment_id: props.old_appointmrntId }
            RestAPIService.create(data, DoctorNotesApiMap[props.field_name])
                .then((response) => {
                    if (response?.data?.status === 'success') {
                        props.successMsgFunc(response.data.message)
                        // Refresh the corresponding component
                        props.triggerRefresh(props.field_name);
                        updateState({ moveIpPopup: false })
                        closemovePop()
                    }
                }).catch((error) => {
                    props.errorMsgFunc(error?.response?.data?.message || error.message)
                    closemovePop()
                })
        } catch (error) {
            props.errorMsgFunc(error.message)
            closemovePop()
        }
    }

    const PastComplaints = (data) => (
        <CardContent sx={{ padding: "0.75rem 1rem" }}>
            {data.length > 0 ? (
                data.map((item, index) => (
                    <div key={index} style={{ marginBottom: ".8rem" }}>
                        <div style={{ fontWeight: "600", color: "#444" }}>
                            {index + 1}. Symptom: {item.symptom_details}
                        </div>
                        <div>Area: {item.area_details}</div>
                        <div>Description: {item.description}</div>
                        <div>Status: {item.status_details}</div>
                        <div>Degree: {item.degree}</div>
                        <div>Remarks: {item.remarks}</div>
                    </div>
                ))
            ) : (
                <div style={{ color: "#aaa" }}>No complaints found</div>
            )}
        </CardContent>
    );

    const ExpectedOutCome = (data) => (
        <CardContent sx={{ padding: "0.75rem 1rem" }}>
            {data.length > 0 ? (
                data.map((item, index) => (
                    <div key={index} style={{ marginBottom: ".8rem" }}>
                        <div style={{ fontWeight: "600", color: "#444" }}>
                            {index + 1}. Expected Outcome: {item.expected_outcome_details}
                        </div>
                        <div>Status: {item.status}</div>
                        <div>Degree of Change: {item.degree_of_change}</div>
                        <div>Remarks: {item.remarks}</div>
                    </div>
                ))
            ) : (
                <div style={{ color: "#aaa" }}>No expected outcomes found</div>
            )}
        </CardContent>
    );

    const PresentComplaints = (data) => (
        <CardContent sx={{ padding: "0.75rem 1rem" }}>
            {data.length > 0 ? (
                data.map((item, index) => (
                    <div key={index} style={{ marginBottom: ".8rem" }}>
                        <div style={{ fontWeight: "600", color: "#444" }}>
                            {index + 1}. Symptom: {item.symptom_details}
                        </div>
                        <div>Area: {item.area_details}</div>
                        <div>Description: {item.description}</div>
                        <div>Intensity: {item.intensity}</div>
                        <div>Duration: {item.duration_value + " " + item.duration_unit}</div>
                        <div>A/R By: {item.ar_by}</div>
                    </div>
                ))
            ) : (
                <div style={{ color: "#aaa" }}>No expected outcomes found</div>
            )}
        </CardContent>
    );

    const SystemicExamination = (data) => (
        <CardContent sx={{ padding: "0.75rem 1rem" }}>
            {data.length > 0 ? (
                data.map((item, index) => (
                    <div key={index} style={{ marginBottom: ".8rem" }} >
                        <div style={{ fontWeight: "600", color: "#444" }}>
                            {index + 1}. System: {item.system_details}
                        </div>
                        <div>Part: {item.part}</div>
                        <div>Element: {item.element_details}</div>
                        <div>Findings: {item.finding}</div>
                        <div>Follow-up: {item.has_followup ? "Yes" : "No"}</div>
                        <div>Frequency: {item.frequency}</div>
                        <div>Remarks: {item.remarks}</div>
                    </div>
                ))
            ) : (
                <div style={{ color: "#aaa" }}>No expected outcomes found</div>
            )}
        </CardContent>
    );

    const AyurvedicDiagnosis = (data) => (
        <CardContent sx={{ padding: "0.75rem 1rem" }}>
            {data.length > 0 ? (
                data.map((item, index) => (
                    <div key={index} style={{ marginBottom: ".8rem" }}>
                        <div>Code: {item.code}</div>
                        <div>Classification: {item.classification}</div>
                        <div>Dosha: {item.dosha}</div>
                        <div>Dooshya: {item.dooshya}</div>
                        <div>Srotas: {item.srotas}</div>
                        <div>Saama: {item.saama ? "Yes" : "No"}</div>
                        <div>Description: {item.description || "—"}</div>
                    </div>
                ))
            ) : (
                <div style={{ color: "#aaa" }}>No Ayurvedic Diagnosis found</div>
            )}
        </CardContent>
    );

    const AllopathicDiagnosis = (data) => (
        <CardContent sx={{ padding: "0.75rem 1rem" }}>
            {data.length > 0 ? (
                data.map((item, index) => (
                    <div key={index} style={{ marginBottom: ".8rem" }}>
                        <div style={{ fontWeight: "600", color: "#444" }}>
                            {index + 1}. Category Code: {item.category_code}
                        </div>
                        <div>Category: {item.category}</div>
                        <div>Disease Code: {item.disease_code}</div>
                        <div>Disease: {item.disease}</div>
                        <div>Subdivision Code: {item.subdivision_code}</div>
                        <div>Subdivision: {item.subdivision}</div>
                    </div>
                ))
            ) : (
                <div style={{ color: "#aaa" }}>No Allopathic Diagnosis found</div>
            )}
        </CardContent>
    );

    const CurrentAllopathicDiagnosis = (data) => (
        <CardContent sx={{ padding: "0.75rem 1rem" }}>
            {data.length > 0 ? (
                data.map((item, index) => (
                    <div key={index} style={{ marginBottom: ".8rem" }}>
                        <div style={{ fontWeight: "600", color: "#444" }}>
                            {index + 1}. Brand: {item.brand}
                        </div>
                        <div>From Field: {item.from_field}</div>
                        <div>Molecule: {item.molecule}</div>
                        <div>Strength: {item.strength}</div>
                        <div>Dosage: {item.dosage}</div>
                    </div>
                ))
            ) : (
                <div style={{ color: "#aaa" }}>No Allopathic Diagnosis found</div>
            )}
        </CardContent>
    );


    const GeneralAdvice = (data) => (
        <CardContent sx={{ padding: "0.75rem 1rem" }}>
            <div>{data[0].advice_text}</div>
        </CardContent>
    );

    const PatientCategory = (data) => {
        return (
            <CardContent sx={{ padding: "0.75rem 1rem" }}>
                {
                    data?.length > 0 ? data.map((item, index) => (
                        <Chip
                            size='small'
                            className={`eMed_chip ${'eMed_Chip_Border'}`}
                            key={index}
                            label={item}
                            variant={"outlined"}
                        />
                    )) : null
                }
            </CardContent>
        )
    }

    const renderVisitRecords = () => {
        switch (props.field_name?.toLowerCase()) {
            case "patient_categories":
                return PatientCategory(props.value)
            case "past_presenting_complaints":
                return PastComplaints(props.value);
            case "expected_outcome":
                return ExpectedOutCome(props.value);
            case "new_presenting_complaints":
                return PresentComplaints(props.value)
            case "systemic_examination":
                return SystemicExamination(props.value)
            case "ayurvedic_diagnosis":
                return AyurvedicDiagnosis(props.value)
            case "allopathic_diagnosis":
                return AllopathicDiagnosis(props.value)
            case "current_allopathic_medication":
                return CurrentAllopathicDiagnosis(props.value)
            case "general_advice":
                return GeneralAdvice(props.value)
            default:
                return null;
        }
    };

    return (
        <div style={{ width: "100%" }}>
            <div style={{ marginBottom: "1.5rem" }}>
                <div
                    style={{
                        fontWeight: "600",
                        color: "#666",
                        textTransform: "uppercase",
                        fontSize: "0.9rem",
                        marginBottom: "0.5rem",
                    }}
                >
                    {props?.label}
                    <Tooltip title="Copy to Current Appointment">
                        <IconButton size="small" onClick={() => updateState({ movePopup: true })}>
                            <ContentCopyIcon style={{ color: "#0a7de2ff" }} fontSize="small" />
                        </IconButton>
                    </Tooltip>
                </div>
                <Card
                    variant="outlined"
                    style={{
                        borderRadius: "8px",
                        borderColor: "#ddd",
                        boxShadow: "none",
                        padding: "0px",
                        height: "10vw",
                        overflowY: "scroll"
                    }}
                >
                    {renderVisitRecords()}
                </Card>
            </div>
            {state.movePopup ?
                <ConfirmPopup
                    cnfTitle={'Confirmation'}
                    cnfContent1={'Do you want to Copy this data into current appointment ?'}
                    cnfAlertPopupClose={closemovePop.bind(this)}
                    cnfData={confirmMovedata.bind(this)}
                />
                : null
            }
        </div>
    );
};

export default DocLastVisitRecords;
